export default (state = null, payload) => {
  switch (payload.type) {
    /*case 'UPDATE_VIDEO':
            let newState = new Date();
        	return newState; */
    default:
      return state;
  }
};
